import React, {lazy, Suspense, useEffect, useRef} from 'react'
import {useSelector} from 'react-redux'
import {useIsFeatureToggledChatEnabled} from 'hooks/useIsFeatureToggledChatEnabled'

import {useRegisterBlockingSurface} from '@vio/atlas/src/context/blockingSurfaces'

import {getIsChatOpen} from '../../modules/vioMcpChat/modules/selectors'

const chatModulePromise = () =>
  import('../../modules/vioMcpChat').then(mod => ({
    default: mod.ChatWidgetContainer
  }))

const LazyChatWidgetContainer = lazy(chatModulePromise)

export const LazyChatWidget = () => {
  const isFeatureToggledChatEnabled = useIsFeatureToggledChatEnabled()
  const isOpen = useSelector(getIsChatOpen)
  const hasBeenOpened = useRef(false)

  useRegisterBlockingSurface(isOpen)

  useEffect(() => {
    if (isFeatureToggledChatEnabled) {
      chatModulePromise()
    }
  }, [isFeatureToggledChatEnabled])

  if (isOpen) {
    hasBeenOpened.current = true
  }

  if (!hasBeenOpened.current) return null

  return (
    <Suspense fallback={null}>
      <LazyChatWidgetContainer />
    </Suspense>
  )
}
